import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Screens/Home";
import Login from "./Screens/Login";
import Layout from "./Screens/Layout/Layout.js";
import Register from "./Screens/Register";
import { Navigate } from "react-router-dom";
import Customers from "./Screens/Customers";
import Services from "./Screens/Services";
import Tires from "./Screens/Tires";
import Vehicles from "./Screens/Vehicles";
import AddReceipts from "./Screens/AddReceipts.js";
import EditReceipt from "./Screens/EditReceipt";
import Oils from "./Screens/Oils";
import Parts from "./Screens/Parts";
import Receipts from "./Screens/AllReceipts";
import Estimates from "./Screens/AllEstimates";
import UnpaidReceipts from "./Screens/UnpaidReceipts";
import TodayReceipts from "./Screens/TodayReceipts";
import ReceiptDetails from "./Screens/ReceiptDetails/ReceiptDetail.js";
import MakePayment from "./Screens/MakePayment";
import DailyReports from "./Screens/DailyReports";
import DailyPaymentHistory from "./Screens/DailyPaymentHistory";
import BulkPaymentHistory from "./Screens/BulkPaymentHistory";
import WeeklyReports from "./Screens/WeeklyReports";
import MonthlyReports from "./Screens/MonthlyReports";
import Reports from "./Screens/Reports";
import PartReports from "./Screens/PartReports";
import TireAnalysisReport from "./Screens/TireAnalysisReport";
import Roles from "./Screens/Roles";
import Teams from "./Screens/Teams";
import ProfileSettings from "./Screens/ProfileSettings";
import Permissions from "./Screens/Permissions";
import CustomerReceipts from "./Screens/CustomerReceipts";
import VehicleReceipts from "./Screens/VehicleReceipts";
import Settings from "./Screens/Settings";
import TaxSettings from "./Screens/TaxSettings";
import Vendors from "./Screens/Vendors";
import Locations from "./Screens/Locations";
import ShopProfile from "./Screens/ShopProfile";
import CheckIn from "./Screens/CheckIn";
import Appointments from "./Screens/Appointments";
import Helpers from "./Config/Helpers";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (_error) {
    return null;
  }
};

function Auth({ children, allowCheckInOnly = false }) {
  const location = useLocation();
  let user = localStorage.getItem("user");
  let token = localStorage.getItem("token");
  let timeNow = new Date().getTime();
  let loginTime = localStorage.getItem("timestamp");
  let afterLogin = (timeNow - loginTime) / 1000;
  let totalMinutes = afterLogin / 60;
  if (totalMinutes > 120) {
    localStorage.clear();
    return <Navigate to="/" state={{ from: location.pathname + location.search }} replace />;
  } else if (user && token && Helpers.isCheckInOnlyUser(getStoredUser()) && !allowCheckInOnly) {
    return <Navigate to="/checkin" replace />;
  } else {
    return user && token ? children : <Navigate to="/" state={{ from: location.pathname + location.search }} replace />;
  }
}

function AfterAuth({ children }) {
  let user = localStorage.getItem("user");
  let token = localStorage.getItem("token");
  if (!(user && token)) return children;
  return Helpers.isCheckInOnlyUser(getStoredUser())
    ? <Navigate to="/checkin" />
    : <Navigate to="/user/dashboard" />;
}
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          index
          element={
            <AfterAuth>
              <Login />
            </AfterAuth>
          }
        ></Route>
        <Route
          path="/register"
          element={
            <AfterAuth>
              <Register />
            </AfterAuth>
          }
        ></Route>
        <Route
          path="/checkin"
          element={
            <Auth allowCheckInOnly>
              <CheckIn />
            </Auth>
          }
        ></Route>
        <Route
          path="/user"
          element={
            <Auth>
              <Layout />
            </Auth>
          }
        >
          <Route
            path="/user/dashboard"
            element={
              <Auth>
                <Home />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/services"
            element={
              <Auth>
                <Services />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/tires"
            element={
              <Auth>
                <Tires />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/vehicles"
            element={
              <Auth>
                <Vehicles />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/customers"
            element={
              <Auth>
                <Customers />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/appointments"
            element={
              <Auth>
                <Appointments />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/edit/:receiptId"
            element={<Auth><EditReceipt /></Auth>}
          ></Route>
          <Route
            path="/user/receipts/add"
            element={
              <Auth>
                <AddReceipts />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/add/:draftId"
            element={
              <Auth>
                <AddReceipts />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/oils"
            element={
              <Auth>
                <Oils />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/parts"
            element={
              <Auth>
                <Parts />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts"
            element={
              <Auth>
                <Receipts />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/estimates"
            element={
              <Auth>
                <Estimates />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/quotes"
            element={<Navigate to="/user/estimates" replace />}
          ></Route>
          <Route
            path="/user/receipts/unpaid"
            element={
              <Auth>
                <UnpaidReceipts />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/today"
            element={
              <Auth>
                <TodayReceipts />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/receipt-details/:receipt_id"
            element={
              <Auth>
                <ReceiptDetails />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/unpaid-receipt/make-payment/:receipt_id"
            element={
              <Auth>
                <MakePayment />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports"
            element={
              <Auth>
                <Reports />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/daily"
            element={
              <Auth>
                <DailyReports />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/daily-payments"
            element={
              <Auth>
                <DailyPaymentHistory />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/bulk-payments"
            element={
              <Auth>
                <BulkPaymentHistory />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/bulk-payments/:bulk_payment_id"
            element={
              <Auth>
                <BulkPaymentHistory />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/weekly"
            element={
              <Auth>
                <WeeklyReports />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/monthly"
            element={
              <Auth>
                <MonthlyReports />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/parts"
            element={
              <Auth>
                <PartReports />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/reports/tire-analysis"
            element={
              <Auth>
                <TireAnalysisReport />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/roles"
            element={
              <Auth>
                <Roles />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/manage-permissions/:role_name/:role_id"
            element={
              <Auth>
                <Permissions />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/employee"
            element={
              <Auth>
                <Teams />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/settings"
            element={
              <Auth>
                <Settings />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/tax-settings"
            element={
              <Auth>
                <TaxSettings />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/profile-settings"
            element={
              <Auth>
                <ProfileSettings />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/shop-profile"
            element={
              <Auth>
                <ShopProfile />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/locations"
            element={
              <Auth>
                <Locations />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/vendors"
            element={
              <Auth>
                <Vendors />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/customer/:customer_name/:customer_id"
            element={
              <Auth>
                <CustomerReceipts />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/customer/:customer_name/:customer_id/bulk-payments"
            element={
              <Auth>
                <BulkPaymentHistory />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/customer/:customer_name/:customer_id/bulk-payments/:bulk_payment_id"
            element={
              <Auth>
                <BulkPaymentHistory />
              </Auth>
            }
          ></Route>
          <Route
            path="/user/receipts/vehicle/:vehicle_name/:vehicle_id"
            element={
              <Auth>
                <VehicleReceipts />
              </Auth>
            }
          ></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
